import { getAppIds } from '~contextProviders/uiIds/AppIdContextProvider';
import { getPageIds } from '~contextProviders/uiIds/PageIdContextProvider';
import { getComponentIds } from '~contextProviders/uiIds/ComponentIdContextProvider';
import {
  APP_IDS,
  COMPONENT_IDS,
  PAGE_IDS,
  UiId,
  UiIds,
  UiIdStr,
} from '~src/constants';
import { OptionalValues } from '~src/types';

export function getUiIds() {
  return {
    appIds: getAppIds(),
    pageIds: getPageIds(),
    componentIds: getComponentIds(),
  };
}

// export function uiIdsStrToId(uiIdStr: UiIdStr): UiId {
//   if (!uiIdStr) {
//     return {}
//   }
//
//   return {
//     appId: uiIdStr.appId && APP_IDS[uiIdStr.appId],
//     pageId: uiIdStr.pageId && PAGE_IDS[uiIdStr.pageId],
//     componentId: uiIdStr.componentId && COMPONENT_IDS[uiIdStr.componentId],
//   }
// }

export function uiIdStrToId(uiIdStr: UiIdStr): UiId {
  if (!uiIdStr) {
    return {};
  }

  return {
    appId: (uiIdStr.appId && APP_IDS[uiIdStr.appId]) || void 0,
    pageId: (uiIdStr.pageId && PAGE_IDS[uiIdStr.pageId]) || void 0,
    componentId:
      (uiIdStr.componentId && COMPONENT_IDS[uiIdStr.componentId]) || void 0,
  };
}

export function uiIdsConcat(
  ...uiIdsArr: (OptionalValues<UiIds> & UiId)[]
): UiIds {
  const result: UiIds = {
    appIds: [],
    pageIds: [],
    componentIds: [],
  };

  for (let i = 0, len = uiIdsArr.length; i < len; i++) {
    const uiIds = uiIdsArr[i];

    if (uiIds.appIds) {
      result.appIds.push(...uiIds.appIds);
    }
    if (uiIds.pageIds) {
      result.pageIds.push(...uiIds.pageIds);
    }
    if (uiIds.componentIds) {
      result.componentIds.push(...uiIds.componentIds);
    }

    if (uiIds.appId) {
      result.appIds.push(uiIds.appId);
    }
    if (uiIds.pageId) {
      result.pageIds.push(uiIds.pageId);
    }
    if (uiIds.componentId) {
      result.componentIds.push(uiIds.componentId);
    }
  }

  return result;
}

export function uiIdsToNames(uiIds?: UiIds) {
  if (!uiIds) {
    return 'null';
  }

  return {
    appIds: uiIds.appIds && uiIds.appIds.map((o) => APP_IDS[o]),
    pageIds: uiIds.pageIds && uiIds.pageIds.map((o) => PAGE_IDS[o]),
    componentIds:
      uiIds.componentIds && uiIds.componentIds.map((o) => COMPONENT_IDS[o]),
  };
}

export function uiIdsToString(uiIds?: UiIds) {
  const names = uiIdsToNames(uiIds);
  return JSON.stringify(names, null, 2);
}
